/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/document';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrieveGeorgiaFinanceDisclosureDocumentRequest": {
                "fields": {}
              },
              "RetrieveGeorgiaFinanceDisclosureDocumentResponse": {
                "fields": {
                  "document": {
                    "type": ".squareup.corporate_card.resources.Document",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveGeorgiaFinanceDisclosureDocumentRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveGeorgiaFinanceDisclosureDocumentResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveGeorgiaFinanceDisclosureDocumentRequest @ squareup/corporate_card/service/retrieve_georgia_finance_disclosure_document.proto at 9:1
 */
export const RetrieveGeorgiaFinanceDisclosureDocumentRequest = $root.lookupType('squareup.corporate_card.service.RetrieveGeorgiaFinanceDisclosureDocumentRequest');
fixType(RetrieveGeorgiaFinanceDisclosureDocumentRequest);
Builder.createAndAttachToType(RetrieveGeorgiaFinanceDisclosureDocumentRequest);
/**
 * SOURCE RetrieveGeorgiaFinanceDisclosureDocumentResponse @ squareup/corporate_card/service/retrieve_georgia_finance_disclosure_document.proto at 15:1
 */
export const RetrieveGeorgiaFinanceDisclosureDocumentResponse = $root.lookupType('squareup.corporate_card.service.RetrieveGeorgiaFinanceDisclosureDocumentResponse');
fixType(RetrieveGeorgiaFinanceDisclosureDocumentResponse);
Builder.createAndAttachToType(RetrieveGeorgiaFinanceDisclosureDocumentResponse);